import { createSlice } from '@reduxjs/toolkit';

interface BottomBarState {
  dailyLogOpen: boolean;
  protecteeMoveOpen: boolean;
  currentlyOpenLog: string;
  currentlyOpenDescription: string;
  expanded: boolean;
}

const initialState: BottomBarState = {
  expanded: false,
  dailyLogOpen: false,
  protecteeMoveOpen: false,
  currentlyOpenLog: '',
  currentlyOpenDescription: '',
};

const bottomBar = createSlice({
  name: 'bottomBar',
  initialState,
  reducers: {
    expand: (state) => {
      state.expanded = !state.expanded;
    },
    toggleDailyLogOpen: (state) => {
      state.dailyLogOpen = !state.dailyLogOpen;
      state.currentlyOpenLog = 'logIcon';
      state.currentlyOpenDescription = 'Log';
      //need to close other open windows
      state.protecteeMoveOpen = false;
    },
    toggleProtecteeMovOpen: (state) => {
      state.protecteeMoveOpen = !state.protecteeMoveOpen;
      state.currentlyOpenLog = 'mov';
      state.currentlyOpenDescription = 'Protectee Location';
      //need to close other open windows
      state.dailyLogOpen = false;
    },
    resetCurrentlyOpenLog: (state) => {
      state.currentlyOpenLog = '';
    },
  },
});

export const {
  expand,
  toggleDailyLogOpen,
  toggleProtecteeMovOpen,
  resetCurrentlyOpenLog,
} = bottomBar.actions;

export default bottomBar.reducer;
